import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=0f04fc18&scoped=true"
import script from "./Staffs.vue?vue&type=script&lang=js"
export * from "./Staffs.vue?vue&type=script&lang=js"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=0f04fc18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04fc18",
  null
  
)

export default component.exports